import gql from "graphql-tag";

export const brokerageBrProfile = gql `
  query brokerageBrProfile($brokerId: String!,$token:String!) {
    BrokerageBrProfile(brokerageId:$brokerId,token:$token){
      email,
      name,
      surname,
      phoneNumber,
      su_pp_path,
      sbad_brokerageName,
      sbad_brokerageLogoRef,
      sbad_fsb,
      sbad_streetAddress,
      sbad_contact_email,
      sbad_contact_phone,
      sbd_broker_app_code,
      sbad_brokerage_code,
      sbad_KP_contact_email,
      user_phone_number
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/BrokerageBrProfile.js